module.exports = __webpack_public_path__ + "static/media/sgen.c5e9fe7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/sgen.png
// module id = 67
// module chunks = 0